import React from 'react';
import { Button } from '@material-ui/core';
import { EditableQuestion } from '../../../../../../types';
import { useDeleteQuestion } from './hooks/useDeleteQuestion';

interface Props {
  question: EditableQuestion;
}

const DeleteButton = ({ question }: Props) => {
  const deleteQuestion = useDeleteQuestion(question);

  const handleDeleteWithConfirmation = () => {
    if (confirmDeletion(question)) {
      deleteQuestion();
    }
  };

  return (
    <Button onClick={handleDeleteWithConfirmation} variant="contained" color="primary">
      Delete
    </Button>
  );
};

const confirmDeletion = (question: EditableQuestion) => {
  return window.confirm(`Are you sure you want to delete this question (${question.question || 'No title question'})?`);
};

export default DeleteButton;
